import { memo } from 'react'
import { ReactElementType } from 'react-window'

import { TextWithLinks } from '@modules/profile/TextWithLink'

import { FieldSectionContainer, FieldText, FieldTitle } from './ResultProfileList.styles'

export interface FieldSectionProps {
  fields: {
    value?: string
    label?: string
    id?: string
  }[]
  wrapper: ReactElementType
}

const FieldSectionRow = ({ fields, wrapper: Wrapper }: FieldSectionProps) => {
  if (!fields?.length) {
    return null
  }

  return (
    <Wrapper>
      {fields.map(({ value, label, id }) => {
        if (!value) {
          return null
        }

        return (
          <FieldSectionContainer key={label + value} id={id}>
            {!!label && <FieldTitle variant="h3">{label}</FieldTitle>}
            <FieldText variant="body1" id={id}>
              <TextWithLinks text={value} />
            </FieldText>
          </FieldSectionContainer>
        )
      })}
    </Wrapper>
  )
}

export default memo(FieldSectionRow)
